const state= {
    items:{
        data:[],
        total:0,
    },
    item: {
        ld_number : null,
        ld_date : new Date(),
        status : "Draft",
        client_contract_id : null,
        gl_code_id : null,
        fm_code_id : null,
        supplier_id : null,
        order_id : null,
        total : null,
        reasons : null,
        description : null,
        created_at: null,
        gl_code : null,
        fm_code : null,
        contract : null,
        supplier : null,
        payment_voucher : null,
        created_by_user: null,
        issue_date_budget: null,
    },
};

const getters = {
    items: (state) => state.items,
    item: (state) => state.item,
};


const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/liquidated-damages`, {params:params})
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getItem({commit}, id){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/liquidated-damages/${id}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit( 'setItem', response.data.data);
                    resolve( response );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    async createItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/liquidated-damages`, data)
                .then(response => {
                    commit( 'setItem', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/liquidated-damages/${data.id}`, data)
                .then(response => {
                    commit( 'setItem', response.data.data);
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/liquidated-damages`, {
                data:{
                    ids: ids
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state, data) {
        state.items = Object.assign(state.item,data);
    },
    setItem (state, data) {
        state.item = data;
    },
    resetItem (state) {
        state.item = {
            ld_number : null,
            ld_date : new Date(),
            status : "Draft",
            client_contract_id : null,
            gl_code_id : null,
            supplier_id : null,
            order_id : null,
            total : null,
            reasons : null,
            description : null,
            created_at : null,
            gl_code : null,
            contract : null,
            supplier : null,
            payment_voucher : null,
            created_by_user: null,
            issue_date_budget: null,
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
